import MedicalSituationAdmission from './MedicalSituationAdmission'

export default class HealthHiringInsuredMedicalSituation {
  private _medical!: MedicalSituationAdmission[]
  private _surgical!: MedicalSituationAdmission[]
  private _cancer!: MedicalSituationAdmission[]
  private _symptoms!: MedicalSituationAdmission[]

  filled: boolean | null

  constructor(data: Partial<HealthHiringInsuredMedicalSituation> = {}) {
    this.medical = data.medical
    this.surgical = data.surgical
    this.cancer = data.cancer
    this.symptoms = data.symptoms

    this.filled = data.filled ?? null
  }

  get medical(): MedicalSituationAdmission[] {
    return this._medical
  }

  set medical(admissions: MedicalSituationAdmission[] | undefined) {
    this._medical = admissions?.map((a) => new MedicalSituationAdmission(a)) ?? []
  }

  get surgical(): MedicalSituationAdmission[] {
    return this._surgical
  }

  set surgical(admissions: MedicalSituationAdmission[] | undefined) {
    this._surgical = admissions?.map((a) => new MedicalSituationAdmission(a)) ?? []
  }

  get cancer(): MedicalSituationAdmission[] {
    return this._cancer
  }

  set cancer(admissions: MedicalSituationAdmission[] | undefined) {
    this._cancer = admissions?.map((a) => new MedicalSituationAdmission(a)) ?? []
  }

  get symptoms(): MedicalSituationAdmission[] {
    return this._symptoms
  }

  set symptoms(admissions: MedicalSituationAdmission[] | undefined) {
    this._symptoms = admissions?.map((a) => new MedicalSituationAdmission(a)) ?? []
  }

  isEmpty() {
    return !this.filled
  }

  updateAttributes(newAttributes: Partial<HealthHiringInsuredMedicalSituation>) {
    Object.assign(this, newAttributes)
  }
}
